import React from 'react'

import styled from 'styled-components'

const RadioButtonGroup = ({
  title,
  list,
  onChange,
  selected,
  name = 'status',
}) => {
  return (
    <StyledWrapper>
      <label>{title}</label>
      <div className="radio__btns">
        {list.map((e, i) => (
          <StyledRadioButton key={i}>
            <div className="radio">
              <input
                className="radio__input"
                type="radio"
                name={name}
                value={e.value}
                checked={selected === e.value}
                onChange={(e) => onChange(e.target.value)}
              />
              <label htmlFor="graduated" className="small-subTitle">
                {e.label}
              </label>
            </div>
          </StyledRadioButton>
        ))}
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  label {
    font-size: 0.875rem;
    font-weight: 300;
    color: #0e1324;
    letter-spacing: 3%;
    line-height: 1.7;
  }

  .radio__btns {
    display: flex;
    flex-wrap: wrap; /* allow wrapping */
    align-items: center;
    margin-top: 1rem;
    gap: 1rem; /* space between buttons */
  }
`

const StyledRadioButton = styled.div`
  display: flex;
  align-items: center;

  flex: 1 1 auto; /* allow growing and shrinking */
  min-width: 120px; /* optional: don't shrink too small */
  max-width: 100%;

  .radio {
    display: flex;
    align-items: center;
    white-space: nowrap;

    .radio__input {
      opacity: 1;
      accent-color: #ff7b9b;
      width: 19px;
      height: 19px;
    }

    label {
      margin: 0;
      padding: 0;
      margin-left: 10px;
    }
  }
`

export default RadioButtonGroup
